import { oc } from '@orpc/contract';
import { tenantUserSchema, updateUserRoleInputSchema } from '../schemas/users.schemas.js';
export const updateUserRoleContract = oc
    .route({
    method: 'POST',
    path: '/users/{userId}/role',
    tags: ['Users'],
    summary: "Change a member's role; the user's live sessions are re-issued on the next refresh",
})
    .input(updateUserRoleInputSchema)
    .output(tenantUserSchema);
//# sourceMappingURL=update-user-role.contract.js.map